import { render, staticRenderFns } from "./PAPayment.vue?vue&type=template&id=d8070c74&"
import script from "./PAPayment.vue?vue&type=script&lang=js&"
export * from "./PAPayment.vue?vue&type=script&lang=js&"
import style0 from "./PAPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAPayment.vue"
export default component.exports